<template>
  <div class="c-hero">
    <div class=" c-hero__title">
      <h3 v-if="strap.length && strap[0].text" class=" c-hero__title__kicker"><anim-text :text="strap[0].text" /></h3>
      <h1 v-if="title" class=" c-hero__title__main" :class="titleClass">
        <anim-text :text="title" />
      </h1>
      <prismic-rich-text v-if="desc[0] && desc[0].text" class="l-section__desc c-hero__title__desc" :field="desc" />
    </div>
  </div>
</template>

<script>
import AnimText from "objects/AnimText";
import PrismicRichText from "objects/PrismicRichText";
export default {
  components: {
    AnimText,
    PrismicRichText
  },
  props: {
    btnReturn: {
      type: Object,
      default: null
    },
    logo: {
      type: Boolean,
      default: false
    },
    logoBottom: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    titleClass: {
      type: String,
      default: "t-t1-heavy"
    },
    desc: {
      type: Array,
      default: () => []
    },
    //  subsidiary smaller headline placed over a main headline
    strap: {
      type: Array,
      required: false,
      default: () => []
    }
  }
};
</script>

<style lang="scss">
.c-hero {
  &__title {
    max-width: 600px; // make sure the title of entrepreneur isn't too wide

    .is-visible & {
      @include anim-text-in(0.6, 0.2);
    }
    &__kicker {
      @include t3-heavy-bold;
      /* @include anim-text-in(0.6, 0.2); */
      margin-bottom: var(--grid-gutter-half);
      .is-visible & {
      }
    }
    &__main {
      .is-visible & {
      }
    }
    &__desc {
      padding-bottom: var(--grid-gutter);
    }
  }
  &__desc {
    transition: all 0.6s $out-quad 0.4s;
    margin-top: 1em;

    @media #{md("md")} {
      font-size: 1.18em;
    }

    .js-reveal & {
      opacity: 0;
      transform: translate(0, 1rem);
    }
    .is-visible & {
      opacity: 1;
      transform: translate(0);
    }
  }
}
</style>
